<template>
  <div class="change-password">

    <h1>{{ isForget?'找回密码':'修改密码' }}</h1>
    <div class="pwd-wrap">
      <el-steps
        :active="active"
        style="margin-bottom: 80px;"
        align-center
      >
        <el-step :title="isForget?'安全验证':'输入原密码'" />
        <el-step title="设置新密码" />
        <el-step title="设置成功" />
      </el-steps>
      <div
        v-if="active===1"
      >
        <div v-if="isForget===true">
          <el-form
            ref="forgetPass"
            :model="forgetPass"
            :rules="forgetRules"
            status-icon
            label-width="120px"
          >
            <el-form-item
              label="邮箱"
              prop="userEmail"
            >
              <el-input
                v-model="forgetPass.userEmail"
                placeholder="输入邮箱"
              />
            </el-form-item>
            <el-form-item
              label="验证码"
              prop="emailCheckCode"
            >
              <el-input
                v-model="forgetPass.emailCheckCode"
                class="checkcode"
                placeholder="输入验证码"
              >
                <!-- <el-button
                  slot="append"
                  :animation="false"
                  :disabled="checkcodeDisabled"
                  :class="['checkcode-btn',checkcodeDisabled?'gray-btn':'']"
                  type="primary"
                  size="large"
                  @click="getEmailCheckCode"
                >{{ emailBtnText }}
                </el-button> -->
                <el-button
                  slot="append"
                  :loading="validCodeLoading"
                  :disabled="codeTime!==0"
                  class="code-btn"
                  @click="getValidCode"
                >{{ codeTime ? codeTime + '秒后重新获取' : '获取验证码' }}</el-button>
              </el-input>
            </el-form-item>
            <div
              class="clickable"
              @click="mailSupport=!mailSupport"
            >收不到验证码？</div>
            <el-button
              type="primary"
              class="next-step"
              @click="checkCode"
            >下一步</el-button>
          </el-form>
          <div
            v-if="mailSupport"
            class="mailSupport"
          >
            <div>收不到验证码？</div>
            <div>请发邮件至 gov-support@gridsum.com 联系管理员</div>
          </div>
        </div>
        <div v-if="isForget===false">
          <el-form
            ref="resetPass"
            :model="resetPass"
            :rules="resetRules"
            status-icon
            label-width="120px"
          >
            <el-form-item
              label="原密码"
              prop="oldPassword"
            >
              <el-input
                v-model="resetPass.oldPassword"
                type="password"
                placeholder="请输入原密码"
              />
            </el-form-item>
            <div
              class="clickable"
              @click="toForget"
            >忘记密码？
            </div>
            <el-button
              type="primary"
              class="next-step"
              @click="checkOld('resetPass')"
            >下一步</el-button>
          </el-form>
        </div>
      </div>
      <div v-if="active===2">
        <el-form
          ref="newPass"
          :model="newPass"
          :rules="newRules"
          status-icon
          label-width="120px"
        >
          <el-form-item
            label="新密码"
            prop="newPassword"
          >
            <el-input
              v-model="newPass.newPassword"
              type="password"
              placeholder="请输入新密码"
              @blur="checkNew"
            />
          </el-form-item>
          <el-form-item
            label="再次输入"
            prop="reNewPassword"
          >
            <el-input
              v-model="newPass.reNewPassword"
              type="password"
              class="checkcode"
              placeholder="请再次输入新密码"
            />
          </el-form-item>
          <el-button
            type="primary"
            class="next-step"
            @click="submitNew"
          >重置密码</el-button>
        </el-form>
      </div>
      <div v-if="active===3">
        <div>
          <img src="../../assets/img/success.png">
          <h1>重置密码成功！</h1>
          <h2>请返回<el-button
            type="text"
            style="font-size:16px"
            @click="backToHome"
          > 首页 </el-button>重新登录</h2>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {formValidate} from '@/service/formValidate'
import {userService} from '@/service/httpService'
import cookie from 'vue-cookie'

export default {
  data () {
    let me = this
    return {
      validCodeLoading: false,
      codeTime: 0,
      resetPass: {
        oldPassword: ''
      },
      resetRules: {
        oldPassword: [{validator: me.validateOld, trigger: 'null'}]
      },
      forgetPass: {
        userEmail: '',
        emailCheckCode: '' // 邮箱验证码
      },
      forgetRules: {
        userEmail: [{validator: me.validateEmail, trigger: 'blur'}],
        emailCheckCode: [{validator: me.validateCode, trigger: 'null'}] // 邮箱验证码
      },
      newPass: {
        newPassword: '',
        reNewPassword: ''
      },
      newRules: {
        newPassword: [{validator: me.validateNew, trigger: 'blur'}],
        reNewPassword: [{validator: me.validateRenew, trigger: 'blur'}]
      },
      emailBtnText: '获取验证码', // 获取验证码提示文字
      newPassword: '',
      reNewPassword: '', // 再次输入新密码
      checkcodeDisabled: false, // 获取验证码disabled
      active: 1, // 步骤
      isForget: true, // 是否是找回密码
      mailSupport: false, // 收不到验证码支持
      emailStatus: -1, // 0：未注册 -1：不合格 1：已注册，合格
      codeStatus: 0, // 0：不正确 1:待校验
      passStatus: 1, // 0: 与原密码相同 1：合格
      repassStatus: 0 // 0:两次输入不相同 1：两次输入相同
    }
  },
  watch: {
    '$route' () {
      this.isForget = this.$route.params.type !== '0' // 0 修改密码 1 忘记密码
    }
  },
  mounted () {
    this.isForget = this.$route.params.type !== '0'
    if (this.$route.params.type === '0' && !cookie.get('cird-ticket')) {
      this.$router.replace({path: '/resetPassword/1'})
    }
  },
  methods: {

    // 验证原密码
    validateOld (rule, value, callback) {
      // 验证
      if (value === '') {
        callback(new Error('请输入原密码'))
      }
      let params = {
        password: this.resetPass.oldPassword
      }
      userService.pwdCheck(params).then(res => {
        callback()
      }, () => {
        callback(new Error('密码有误，请重新输入'))
      })
    },
    // 验证验证码
    validateCode (rule, value, callback) {
      if (this.codeStatus === 0) {
        callback(new Error('验证码错误'))
        this.codeStatus = 1
      }
    },
    // 验证邮箱是否注册
    validateEmail (rule, value, callback) {
      let mail = new RegExp('^([a-z0-9A-Z]+[-|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-zA-Z]{2,}$')
      if (!mail.test(value)) {
        this.emailStatus = -1
        callback(new Error('请输入正确的邮箱'))
      } else if (this.emailStatus === 0) {
        callback(new Error('该邮箱尚未注册'))
        this.emailStatus = 1
      } else {
        this.emailStatus = 1
        callback()
      }
      if (this.checkcodeDisabled) {
        this.emailBtnText = '重新发送'
        this.checkcodeDisabled = false
      }
    },

    // 验证新老密码相同
    validateNew (rule, value, callback) {
      let trimVal = value.trim()
      var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,12}$/
      if (trimVal.length < 6 || trimVal.length > 12) {
        callback(new Error('请输入6-12位密码'))
        this.passStatus = -1
      } else if (this.passStatus === 0) {
        this.passStatus = 1
        callback(new Error('与旧密码重复'))
      } else if (!reg.test(value)) {
        this.passStatus = -1
        callback(new Error('密码格式不正确'))
      } else {
        this.passStatus = 1
        callback()
      }
      console.log('this.passStatus : ', this.passStatus)
    },

    // 验证两次输入密码相同
    validateRenew (rule, value, callback) {
      var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,12}$/
      if (value !== this.newPass.newPassword) {
        callback(new Error('两次输入密码必须一致'))
        this.repassStatus = 0
      } else if (!reg.test(value)) {
        this.passStatus = -1
        callback(new Error('密码格式不正确'))
      } else {
        callback()
        this.repassStatus = 1
      }
      formValidate.validatePwdRepeat(this.newPass.newPassword, value, callback)
    },
    // 请求验证码
    getEmailCheckCode () {
      // TODO: 邮箱已注册检查
      // TODO: 请求code
      this.codeStatus = 1
      if (this.emailStatus !== -1) {
        let params = {
          email: this.forgetPass.userEmail
        }
        userService.codeSend(params).then(res => {
          this.emailStatus = 1
          console.log('code sent')
        }, () => {
          this.emailStatus = 0
          this.$refs['forgetPass'].validate(valid => {
            if (!valid) {
              return false
            }
          })
        })
        this.emailBtnText = '已发送'
        this.checkcodeDisabled = true
      }
    },

    // 找回密码->下一步
    checkCode () {
      // TODO: 检查code
      // then this.active = 2
      // catch this.$message
      let params = {
        email: this.forgetPass.userEmail,
        code: this.forgetPass.emailCheckCode
      }
      userService.codeCheck(params).then(res => {
        this.active++
      }, () => {
        this.codeStatus = 0
        this.$refs['forgetPass'].validate(valid => {
          if (!valid) {
            return false
          }
        })
      })
      this.emailBtnText = '重新发送'
      this.checkcodeDisabled = false
    },

    // 检查原密码正确性
    checkOld (ref) {
      // TODO: 请求原密码正确性
      // then this.active = 2
      this.$refs[ref].validate(valid => {
        if (!valid) {
          return false
        } else {
          this.active += 1
        }
      })
    },

    // 提交新密码
    submitNew () {
      // TODO: 提交新密码
      if (this.repassStatus === 1 && this.passStatus === 1) {
        this.changeReset()
      }
    },
    checkNew () {
      this.$refs['newPass'].validate(valid => {
        if (!valid) {
          return false
        }
      })
    },

    // 修改或重置密码
    changeReset () {
      if (this.newPassword === this.reNewPassword) {
        if (this.isForget) {
          let params = {
            email: this.forgetPass.userEmail,
            code: this.forgetPass.emailCheckCode,
            password: this.newPass.newPassword
          }
          userService.pwdReset(params).then(res => {
            this.passStatus = 1
            console.log(res)
            this.active++
          }, err => {
            this.passStatus = 0
            console.log(err)
            this.checkNew()
          })
        } else {
          let params = {
            password: this.newPass.newPassword
          }
          userService.pwdChange(params).then(res => {
            this.passStatus = 1
            console.log(res)
            this.active++
          }, err => {
            this.passStatus = 0
            console.log(err)
            this.checkNew()
          })
        }
      }
    },

    toForget () {
      const {href} = this.$router.resolve({
        path: '/resetPassword/1'
      })
      window.open(href)
    },

    // 获取验证码
    getValidCode () {
      this.$refs.forgetPass.validateField('userEmail', errorMessage => {
        if (errorMessage) {
          this.$message({type: 'error', message: errorMessage})
          return false
        }
        let param = {
          email: this.forgetPass.userEmail
        }

        this.validCodeLoading = true
        userService.codeSend(param).then(res => {
          this.validCodeLoading = false
          this.$message({type: 'success', message: '已将验证码发送至邮箱'})
          this.validateTimer()
        })
        .catch((err) => {
          this.validCodeLoading = false
          let message = err.data.message
          if (message) {
            message = message.split('--')
          }
          this.$message({type: 'error', message: message[1] || '发送验证码失败'})
        })
      })
    },

    validateTimer () {
      let timer = null
      this.codeTime = 60
      timer = window.setInterval(() => {
        if (this.codeTime === 1) {
          clearInterval(timer)
        }
        this.codeTime--
      }, 1000)
    },

    backToHome () {
      this.$store.dispatch('logout')
      this.$store.dispatch('userLogout')
      this.$router.push({name: 'historyNewHome'})
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/member-manage-out/password-reset.vue